import { katTranslator } from '../../shared/i18n';

const strings = {
  kat_hero_extended_info_label: {
    'en-US': 'More details',
  },
};

export default katTranslator(strings);
